<template>
  <div class="fl_nav">
    <ul>
      <li class="li_list li_index">
        <a :href="homeIndex">{{TLang('首页','my')}}</a>
      </li>
      <li
        v-for="(item, index) in res.userCenterMenuItemDtos"
        v-show="item.isShow === 1"
        :key="index"
        :class="
          active1 == true ? 'li_list li_item active' : 'li_list li_item'
        "
      >
        <a
          :href="item.url.length !== 0 ? `${item.url}` : `javascript:;`"
          target="_self"
          @click="menuClick(item.name)"
        >
          {{ item.name }}
          <i
            v-show="item.menuItemDtos !== null"
            class="icon_arrow"
          ></i>
        </a>
        <ul
          v-show="item.menuItemDtos && active1 == true"
          class="li_menu"
        >
          <li
            v-for="(ele, i) in item.menuItemDtos"
            v-show="ele.isShow === 1"
            :key="i"
            :class="
              ele.code === 'order'
                ? 'li_list2 hover'
                : 'li_list2'
            "
          >
            <a :href="ele.url" target="_self">· {{ ele.name }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { getUserMenuListBFD } from '@fetch';
export default {
  name: 'OrderListForBFD',
  data() {
    return (
      {
        homeIndex: '', // 首页地址
        active1: false,
        active2: true,
        res: {},
      }
    );
  },
  created() {
    this.homeIndex = sessionStorage.getItem('homeIndex') || window.location.origin + '/mall';
    getUserMenuListBFD().then(res => {
      this.res = res;
    });
  },
  methods: {
    menuClick() {
      this.active1 = !this.active1;
    },

  },
};
</script>

<style lang="less" scoped>
.fl_nav .li_list a:hover,
.fl_nav .active a {
  background: #393939;
}
.fl_nav .li_list2 a:hover,
.fl_nav .li_list2.hover a {
  color: #e5152e;
}

.center_fr {
  padding-left: 200px;
  width: 100%;
}
.center_box {
  border: 1px solid #eaeaea;
  background: #fff;
  min-height: 600px;
}
.center_title {
  height: 40px;
  line-height: 40px;
  background: #f3f3f3;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  padding-left: 15px;
}
.center_page_wrap {
  width: 1200px;
  margin: 0 auto;
}

.center_page {
  padding-top: 10px;
}
.center_order {
  margin: 15px 0 0px;
  position: relative;
}
.clearfix {
  zoom: 1;
}
.fl_nav {
  width: 180px;
  float: left;
}
ol,
ul {
  list-style: none outside;
  margin: 0;
  padding: 0;
}
.fl_nav .li_list a {
  word-break: normal;
  word-break: break-word;
  color: #fff;
  display: block;
  line-height: 46px;
  height: auto !important;
  padding-left: 40px;
  padding-right: 43px;
  text-align: left !important;
}

.clearfix:after,
.center_page::after {
  content: " ";
  display: block;
  height: 0;
  font-size: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}
.fl_nav .li_list a {
  word-break: normal;
  word-break: break-word;
  color: #fff;
  display: block;
  line-height: 46px;
  height: auto !important;
  padding-left: 40px;
  padding-right: 43px;
  text-align: left !important;
}
a {
  text-decoration: none;
  color: #828282;
}
.fl_nav .li_list a {
  word-break: normal;
  word-break: break-word;
  color: #fff;
  display: block;
  line-height: 46px;
  height: auto !important;
  padding-left: 40px;
  padding-right: 43px;
  text-align: left !important;
}

.fl_nav .li_list > a {
  background: #303030;
  text-align: center;
  border: 1px solid #595959;
  border-bottom: 0;
}
a {
  color: #333;
  text-decoration: none;
  cursor: pointer;
}
.fl_nav .li_index > a {
  background: #e5152e;
  border: 0;
}
.fl_nav .li_list2:first-child a {
  border-top: 1px solid #595959;
}
.fl_nav .li_list2 a {
  padding-left: 40px;
  height: 30px;
  line-height: 30px;
  background: #393939;
  text-align: left !important;
  padding-right: 5px;
}
.fl_nav .li_item {
  position: relative;
}
.fl_nav .li_item.active .icon_arrow {
  background: url('~@assets/images/order/bfd_arrow_top.png') no-repeat;
}
.fl_nav .li_item .icon_arrow {
 background: url('~@assets/images/order/bfd_arrow_bottom.png') no-repeat;
}
.fl_nav .li_item .icon_arrow {
  display: inline-block;
  width: 11px;
  height: 6px;
  position: absolute;
  right: 25px;
  top: 20px;
}
</style>